import { UserResponse } from '../../generated/model/models';
import { httpClient } from '../config/httpClient';
import { addAuthHeader } from '../utils/axios.utils';

const path = {
  getUser: '/user',
};

export const getUser = (token: string) => {
  httpClient.interceptors.request.use(
    (config) => {
      addAuthHeader(config, token);
      return config;
    },
    (response) => {
      return Promise.reject(response);
    },
  );
  return httpClient.get<UserResponse>(path.getUser);
};
